export const BlueHS = () => {
  return (
    <div className="flex justify-center p-2 h-screen">
      <iframe
        className="p-4 h-screen w-screen"
        src="https://iframe.dacast.com/live/34722db9-4e7c-5b6a-03b1-492fb511cfd6/f32fe60b-e476-8b39-ae72-0bc377c6bf65"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Blue HS"
      />
    </div>
  );
};
